export default "/img/QA.6bfd5cf115cad8393f2c81e21b975216.png";